import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    theme: 'light',
    themes:
    {
      dark: {
        primary: '#ffd52f',
        secondary: '#ffd52f',
        accent: '#5A78FF',
        error: '#FF0000'
      },
      light: {
        primary: '#ffd52f',
        secondary: '#ffd52f',
        accent: '#5A78FF',
        error: '#FF0000'
      }
    }
  }
})
